import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class VirtualHostProps {
  @Inlet(Accepts.MarkdownText) public text?: Types["MarkdownText"];
  @Inlet(Accepts.XRTrackable) public trackable?: Types["XRTrackable"];
  @Inlet(Accepts.XRVirtualHost) public renderable?: Types["XRVirtualHost"];

  @Inlet(Accepts.Subtitles) public subtitles?: Types["Subtitles"];
  @Inlet(Accepts.XRVirtualHostEffect)
  public effect?: Types["XRVirtualHostEffect"];

  @Inlet(Accepts.Image) public permissionMedia?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public permissionText?: Types["MarkdownText"];
}

export const VirtualHostDefinition = defineElement(
  "virtual-host",
  VirtualHostProps,
  {
    versionRequired: "0.49.0",
  }
);
